export default (props) => (
  /**
   * Ícone logotipo do GeoBahia com preenchimento
   * na cor azul da identidade visual da aplicação
   */
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95.88 16.02">
    <g id="Especificações">
      <path
        fill="#3c71dd"
        d="M10,2.57q.66.39.66.88a1.08,1.08,0,0,1-.24.68.75.75,0,0,1-.62.31,2.17,2.17,0,0,1-1-.36,4.69,4.69,0,0,0-2.47-.66A4,4,0,0,0,3.38,4.77,4.44,4.44,0,0,0,2.08,8a4.93,4.93,0,0,0,1.15,3.45A3.94,3.94,0,0,0,6.29,12.7a3.13,3.13,0,0,0,2.44-1,3.74,3.74,0,0,0,1-2.41H7.58A.77.77,0,0,1,7,9a.89.89,0,0,1-.22-.61.77.77,0,0,1,.88-.87h2.92a1.08,1.08,0,0,1,.95.34,1.82,1.82,0,0,1,.25,1.06A5.73,5.73,0,0,1,10.19,13a5.45,5.45,0,0,1-4.11,1.6A5.78,5.78,0,0,1,1.73,12.8,6.5,6.5,0,0,1,0,8.11,6.27,6.27,0,0,1,1.9,3.48,6.16,6.16,0,0,1,6.38,1.6,6.69,6.69,0,0,1,10,2.57Z"
      />
      <path
        fill="#3c71dd"
        d="M15.17,1.75l.82,0,2.85,0,1.78,0q1,0,1,.84c0,.52-.17.83-.58.93s-1.72,0-4.32,0h-.81V7.38h.72c.6,0,1.61,0,3-.08a1.71,1.71,0,0,1,.88.16.75.75,0,0,1,.26.71c0,.59-.32.88-1,.88h-4q0,.37,0,1.2,0,.37,0,1.18t0,1.2q.75,0,4.27,0l.92,0c.55,0,.82.31.82.93a.91.91,0,0,1-1,1h-5a3.54,3.54,0,0,1-1.54-.22,1,1,0,0,1-.4-1v-.69a2,2,0,0,1,0-.3c0-.19,0-.45,0-.79s0-.71,0-1.13,0-.91,0-1.48,0-1.13,0-1.68,0-1.25,0-2.26,0-1.77,0-2.28S14.32,1.75,15.17,1.75Z"
      />
      <path
        fill="#3c71dd"
        d="M50,2.67a3.1,3.1,0,0,1,1.19,2.51,3,3,0,0,1-.47,1.68,2.8,2.8,0,0,1-1.22,1.06,3.2,3.2,0,0,1,1.72,1,2.64,2.64,0,0,1,.66,1.83A3.58,3.58,0,0,1,51,13.3a3.78,3.78,0,0,1-2.45,1.1c-.55.06-1.62.11-3.22.11H43.83c-.67,0-1-.42-1.05-1.23l0-3.37V6.11c0-.37,0-.91,0-1.61s0-1.24,0-1.61A1,1,0,0,1,43,2.17a1.12,1.12,0,0,1,.73-.35q.71-.09,3.29-.09A4.6,4.6,0,0,1,50,2.67ZM48.55,4A2.74,2.74,0,0,0,47,3.51q-1.24,0-2.17,0,0,.58,0,3.8h2.26a2.14,2.14,0,0,0,1.53-.58,2,2,0,0,0,.56-1.52A1.5,1.5,0,0,0,48.55,4ZM44.83,9l0,3.73H47.3a3.2,3.2,0,0,0,1.81-.49,1.61,1.61,0,0,0,.7-1.43C49.8,9.6,49,9,47.28,9Z"
      />
      <path
        fill="#3c71dd"
        d="M54.18,12.49,56,8.19l2.3-5.75a1.14,1.14,0,0,1,1.16-.73,1.19,1.19,0,0,1,1.25.77q.32.77,1.23,3.1t1.24,3.15l.12.25a3.15,3.15,0,0,1,.14.33Q64.42,11.65,65,13a1.67,1.67,0,0,1,.17.67.76.76,0,0,1-.34.59,1.24,1.24,0,0,1-.8.27,1.09,1.09,0,0,1-.64-.16,1.27,1.27,0,0,1-.39-.57c-.62-1.58-.95-2.43-1-2.55-.44,0-1.52,0-3.24,0H57c0,.13-.19.48-.42,1.1s-.4,1.05-.51,1.31a2.15,2.15,0,0,1-.38.65.78.78,0,0,1-.59.2,1.46,1.46,0,0,1-.84-.24.83.83,0,0,1-.36-.73A2.72,2.72,0,0,1,54.18,12.49Zm3.37-2.9q2.34,0,3.87,0L59.54,4.24Q59.28,5,57.55,9.59Z"
      />
      <path
        fill="#3c71dd"
        d="M77.43,13.64c0,.61-.34.92-1.07.92s-1-.31-1-.92V12.06l0-2.79-2.94,0-3,0,0,4.38q0,.86-1.11.86t-1-.88q0-.75,0-3.09t0-3.61l-.07-4.29c0-.64.38-1,1.12-1s1,.27,1,.8v2c0,.94,0,1.9,0,2.88h5l1,0q0-.84,0-2.51t0-2.17a.94.94,0,0,1,1.07-1,.9.9,0,0,1,1,1q0,3.07,0,5.52Z"
      />
      <path
        fill="#3c71dd"
        d="M80.45,2.67a.89.89,0,0,1,.31-.75,1.22,1.22,0,0,1,.78-.24,1.16,1.16,0,0,1,.75.23.83.83,0,0,1,.3.66V7.12c0,.3,0,.81,0,1.53s0,1.2,0,1.42v3.43a.93.93,0,0,1-.27.78,1.14,1.14,0,0,1-.78.25,1.18,1.18,0,0,1-.77-.24.89.89,0,0,1-.3-.73q0-.22,0-.8t0-.87l0-5.13Q80.49,5.92,80.45,2.67Z"
      />
      <path
        fill="#3c71dd"
        d="M84.87,12.49l1.85-4.31L89,2.44a1.14,1.14,0,0,1,1.16-.73,1.19,1.19,0,0,1,1.25.77q.32.77,1.23,3.1t1.24,3.15L94,9a3.15,3.15,0,0,1,.14.33q.94,2.34,1.53,3.71a1.67,1.67,0,0,1,.17.67.76.76,0,0,1-.34.59,1.24,1.24,0,0,1-.8.27,1.09,1.09,0,0,1-.64-.16,1.27,1.27,0,0,1-.39-.57c-.62-1.58-.95-2.43-1-2.55-.44,0-1.52,0-3.24,0H87.66c0,.13-.19.48-.42,1.1s-.4,1.05-.51,1.31a2.15,2.15,0,0,1-.38.65.78.78,0,0,1-.59.2,1.46,1.46,0,0,1-.84-.24.83.83,0,0,1-.36-.73A2.72,2.72,0,0,1,84.87,12.49Zm3.37-2.9q2.34,0,3.87,0L90.22,4.24Q90,5,88.24,9.59Z"
      />
      <path
        fill="#3c71dd"
        d="M31.68,2a6,6,0,1,1-2.05.36A6,6,0,0,1,31.68,2h0m0-2A8,8,0,1,0,39.2,5.27,8,8,0,0,0,31.68,0Z"
      />
      <path
        fill="#3c71dd"
        d="M29.91,8.65A31.34,31.34,0,0,1,28.15.82,8,8,0,0,0,27,1.54a32.88,32.88,0,0,0,1.78,7.54A32.88,32.88,0,0,0,32.22,16a8,8,0,0,0,1.38-.22A31.34,31.34,0,0,1,29.91,8.65Z"
      />
      <path
        fill="#3c71dd"
        d="M34,5.33A32.81,32.81,0,0,0,31.13,0a8,8,0,0,0-1.38.22,31.28,31.28,0,0,1,3,5.43C33.17,5.55,33.58,5.44,34,5.33Z"
      />
      <path
        fill="#3c71dd"
        d="M34.62,6.94l-.16-.44-1.21.33.2.53q.53,1.47.91,2.95c.39-.17.78-.34,1.16-.52"
      />
      <polygon
        fill="#3c71dd"
        points="33.24 6.83 33.24 6.83 33.24 6.83 33.24 6.83"
      />
      <path
        fill="#3c71dd"
        d="M34.64,11.55a31.3,31.3,0,0,1,.56,3.65,8,8,0,0,0,1.19-.72A32.79,32.79,0,0,0,35.81,11Z"
      />
      <path
        fill="#3c71dd"
        d="M30.57,10.35a31.28,31.28,0,0,1-6.09,1.18,8,8,0,0,0,.72,1.19,32.81,32.81,0,0,0,5.88-1.22q-.27-.57-.52-1.15Z"
      />
      <path
        fill="#3c71dd"
        d="M39.45,6.09a31.34,31.34,0,0,1-7.13,3.68l-.55.19q.25.58.52,1.14l.45-.16a32.88,32.88,0,0,0,6.92-3.48,8,8,0,0,0-.22-1.38ZM31.77,10h0Zm0,0h0Zm0,0h0Z"
      />
      <path
        fill="#3c71dd"
        d="M38.15,3.29a32.88,32.88,0,0,0-7.54,1.78l-.45.17c.1.4.23.85.33,1.21h0l.55-.2a31.34,31.34,0,0,1,7.83-1.76A8,8,0,0,0,38.15,3.29Z"
      />
      <path
        fill="#3c71dd"
        d="M29,5.7a32.81,32.81,0,0,0-5.31,2.85,8,8,0,0,0,.22,1.38,31.28,31.28,0,0,1,5.43-3C29.22,6.52,29.11,6.11,29,5.7Z"
      />
    </g>
  </svg>
);
